import { Dispatch, SetStateAction, useCallback, useState } from 'react';

export type SliderStateResult = {
  slide: number;
  decrement: () => number;
  increment: () => number;
  isFirst: boolean;
  isLast: boolean;
  goto: Dispatch<SetStateAction<number>>;
};
export const useSliderState = (slides: number): SliderStateResult => {
  const [slide, setSlide] = useState(0);

  const decrement = useCallback(() => {
    const newSlide = Math.max(0, slide - 1);
    setSlide(newSlide);
    return newSlide;
  }, [slide]);
  const increment = useCallback(() => {
    const newSlide = Math.min(slides - 1, slide + 1);
    setSlide(newSlide);
    return newSlide;
  }, [slide, slides]);

  const isFirst = slide === 0;
  const isLast = slide === slides - 1;

  return {
    slide,
    decrement,
    increment,
    isFirst,
    isLast,
    goto: setSlide,
  };
};
